import ModifierPassword from '../components/ModifierPassword'
import useModalForm from '../../../@hooks/useModalForm'
import Service from '../../../@services/user'

export default function useModifierRoleDialog(cb) {
  const { open } = useModalForm(ModifierPassword)

  const openDialog = user => {
    console.log({ user })
    return open(
      async req => {
        const res = await Service.changePassword(req)
        if (typeof cb === 'function') {
          cb(res)
        }
      },
      {
        id: user.id,
        username: user.username,
      },
      {
        title: '修改密码',
      }
    )
  }

  return openDialog
}
